import { A, Div, H, LinkButton, Text } from '@/primitives'

import { css } from '@/styled-system/css'
import {
  RecordingMode,
  useHasRecordingAccess,
  useHasFeatureWithoutAdminRights,
} from '../index'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { RecordingStatus, recordingStore } from '@/stores/recording'
import { FeatureFlags } from '@/features/analytics/enums'
import { useSnapshot } from 'valtio/index'
import { Spinner } from '@/primitives/Spinner'
import { useConfig } from '@/api/useConfig'

export const TranscriptSidePanel = () => {
  const { data } = useConfig()

  const { t } = useTranslation('rooms', { keyPrefix: 'transcript' })

  const recordingSnap = useSnapshot(recordingStore)

  const hasTranscriptAccess = useHasRecordingAccess(
    RecordingMode.Transcript,
    FeatureFlags.Transcript
  )

  const hasFeatureWithoutAdminRights = useHasFeatureWithoutAdminRights(
    RecordingMode.Transcript,
    FeatureFlags.Transcript
  )

  const statuses = useMemo(() => {
    return {
      isStopping: recordingSnap.status == RecordingStatus.TRANSCRIPT_STOPPING,
    }
  }, [recordingSnap])

  return (
    <Div
      display="flex"
      overflowY="scroll"
      padding="0 1.5rem"
      flexGrow={1}
      flexDirection="column"
      alignItems="center"
    >
      <img
        src="/assets/intro-slider/3.png"
        alt={''}
        className={css({
          minHeight: '309px',
          marginBottom: '1rem',
        })}
      />
      {!hasTranscriptAccess ? (
        <>
          {hasFeatureWithoutAdminRights ? (
            <>
              <Text>{t('notAdminOrOwner.heading')}</Text>
              <Text
                variant="note"
                wrap="balance"
                centered
                className={css({
                  textStyle: 'sm',
                  marginBottom: '2.5rem',
                  marginTop: '0.25rem',
                })}
              >
                {t('notAdminOrOwner.body')}
                <br />
                {data?.support?.help_article_transcript && (
                  <A
                    href={data.support.help_article_transcript}
                    target="_blank"
                  >
                    {t('notAdminOrOwner.linkMore')}
                  </A>
                )}
              </Text>
            </>
          ) : (
            <>
              <Text>{t('beta.heading')}</Text>
              <Text
                variant="note"
                wrap={'pretty'}
                centered
                className={css({
                  textStyle: 'sm',
                  marginBottom: '2.5rem',
                  marginTop: '0.25rem',
                })}
              >
                {t('beta.body')}{' '}
                {data?.support?.help_article_transcript && (
                  <A
                    href={data.support.help_article_transcript}
                    target="_blank"
                  >
                    {t('start.linkMore')}
                  </A>
                )}
              </Text>
              {data?.transcript.form_beta_users && (
                <LinkButton
                  size="sm"
                  variant="tertiary"
                  href={data?.transcript.form_beta_users}
                  target="_blank"
                >
                  {t('beta.button')}
                </LinkButton>
              )}
            </>
          )}
        </>
      ) : (
        <>
          {statuses.isStopping ? (
            <>
              <H lvl={3} margin={false}>
                {t('stopping.heading')}
              </H>
              <Text
                variant="note"
                wrap={'pretty'}
                centered
                className={css({
                  textStyle: 'sm',
                  maxWidth: '90%',
                  marginBottom: '2.5rem',
                  marginTop: '0.25rem',
                })}
              >
                {t('stopping.body')}
              </Text>
              <Spinner />
            </>
          ) : (
            <>
              <H lvl={3} margin={false}>
                {t('autoEnabled.heading')}
              </H>
              <Text
                variant="note"
                wrap="balance"
                centered
                className={css({
                  textStyle: 'sm',
                  maxWidth: '90%',
                  marginBottom: '2.5rem',
                  marginTop: '0.25rem',
                })}
              >
                {t('autoEnabled.body')}{' '}
                {data?.support?.help_article_transcript && (
                  <A
                    href={data.support.help_article_transcript}
                    target="_blank"
                  >
                    {t('start.linkMore')}
                  </A>
                )}
              </Text>
            </>
          )}
        </>
      )}
    </Div>
  )
}
